import { createSlice } from '@reduxjs/toolkit';

import { userProfileApi } from './userProfileApi';

const initialState = {
  profileData: {},
};
const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        userProfileApi.endpoints.getUserProfileDetails.matchFulfilled,
        (state, action) => {
          state.profileData = action.payload || {};
        },
      )
      .addMatcher(
        userProfileApi.endpoints.updateProfile.matchFulfilled,
        (state, action) => {
          state.profileData = action.payload || {};
        },
      );
  },
});
export const userProfileReducer = userProfileSlice.reducer;
export const {
  useUpdateProfileMutation,
  useLazyGetUserProfileDetailsQuery,
  useUpdateLicenseFormMutation,
  useVerifyOtpMutation,
} = userProfileApi;

export { userProfileApi };
